import { useState, useEffect, useContext } from "react";
import DebtProject from "./DebtProject";
import AddDebtProjects from "./AddDebtProjects";
import { useParams, Link } from "react-router-dom";
import { AlertV2 } from "../../../../components/Alert";
import { getStationaryList } from "../../../../apis/Business/OtherVehicleApi";
import CompanyComponent, {
  AddDebt,
} from "../../../../components/CompanyComponent";
import Empty2 from "../../../../components/Option/Empty2";
import { createContext } from "react";
import { useTranslation } from "react-i18next";
import { getDebtProjectList } from "../../../../apis/Business/DebtProjectApi";
import { YearTabContext } from "../../../../components/Skeleton";
import { NonCompanyComponent } from "../../../../components/ProductComponent";
import { useUserAccess } from "../../../../components/WriteAccessContext";

export const Header = () => {
  const { t } = useTranslation();
  return (
    <div className="companydetail__group table__header table__project">
      <div className="companydetail__row" style={{ backgroundImage: "none" }}>
        <div
          className="modaladdlocation__question"
          style={{ backgroundImage: "none", backgroundColor: "transparent" }}
        >
          <h6>{t("INVESTMENT_TYPE")}</h6>
        </div>
        <div className="modaladdlocation__question">
          <h6>{t("INVESTEE_NAME")}</h6>
        </div>
        <div className="modaladdlocation__question">
          <h6>{t("PROJECT_PHASE")}</h6>
        </div>
        <div className="modaladdlocation__question">
          <h6>{t("INITIAL_INVESTOR")}</h6>
        </div>
        <div className="modaladdlocation__question">
          <h6>{t("PROJECT_COSTS")}</h6>
        </div>
        <div className="modaladdlocation__question">
          <h6>{t("YOUR_SHARE_DEBT")}</h6>
        </div>
        <div className="modaladdlocation__question">
          <h6>{t("PROJECTED_ANNUAL")}</h6>
        </div>
        <div className="modaladdlocation__question">
          <h6>{t("PROJECTED_LIFETIME")}</h6>
        </div>
        <div className="modaladdlocation__question">
          <h6>{t("SECTOR")}</h6>
        </div>
      </div>
    </div>
  );
};

export const ApiVarDebtProjectContext = createContext();
const DebtProjects = ({ setEditSections }) => {
  const apiVariable = [
    "invesment_type",
    "investee_name",
    "project_phase",
    "initial_investor",
    "project_costs",
    "share_of_costs",
    "projected_carbon",
    "projected_lifetime",
  ];

  const yearTab = useContext(YearTabContext);
  const urlParams = new URLSearchParams(window.location.search);
  const year = urlParams.get("year");

  let { businessId } = useParams();

  const [vehicles, setVehicles] = useState([]);

  const [editVehicles, setEditVehicles] = useState([]);

  const [tipScroll, setTipScroll] = useState("normal");
  const { userAccess } = useUserAccess();

  useEffect(() => {
    if (tipScroll === "scrolled") {
      setTimeout(() => setTipScroll("done"), 3000);
    }
  }, [tipScroll]);

  const [saveSpecial, setSaveSpecial] = useState(false);
  const [saveAllAlert, setSaveAllAlert] = useState(false);

  const { t } = useTranslation();

  const saveAll = () => {
    setSaveSpecial(true);
  };

  useEffect(() => {
    if (yearTab || year)
      getDebtProjectList({ businessId: businessId, setObjects: setVehicles });
  }, [yearTab, year, businessId]);

  return (
    <ApiVarDebtProjectContext.Provider value={apiVariable}>
      {vehicles.map((vehicle, i) => {
        return (
          <Link
            className="nav-link"
            to={`/company/debt/${vehicle.id}?year=` + year}
          >
            <NonCompanyComponent
              index={i}
              name={vehicle.investee_name}
              address_line_1={"" + vehicle.invesment_type}
            />
          </Link>
        );
      })}

      {userAccess === "write" && (
        <Link className="nav-link" to={"/company/add-debt?year=" + year}>
          <AddDebt />
        </Link>
      )}
      <AlertV2
        open={saveAllAlert}
        title={t("SAVE_VEHICLES")}
        accept={() => {
          saveAll();

          setSaveAllAlert(false);
        }}
        decline={() => setSaveAllAlert(false)}
      />

      {/* </div> */}
    </ApiVarDebtProjectContext.Provider>
  );
};

export default DebtProjects;
